import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Left } from '../../../../components/Icon';
import { HBox, VBox } from '../../../../components/Box';
import { ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import styles from './MainModal.module.css';

import { COLOR_BG_LIGHT } from '../../../../vars';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const STATE = {
  addedProps: {},
  isAddSecondContact: false,
  download: true,
  sendToEmail: false,
  relation: null,
  contact: null,
  secondaryRelation: null,
  secondaryContact: null,
  extraEmail: null,
};

const Container = styled.div`
  font-size: 14px;
  .title {
    font-size: 14px;
  }

  strong {
    margin-bottom: 24px;
  }

  .search-top {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_BG_LIGHT};

    .list-result-label {
      font-weight: 500;
      width: 50px;
      margin: 5px;
      text-align: center;
      background-color: black;
      color: #fff;
    }
  }

  .mobile-btn-block {
    position: fixed;
    left: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;
    }
  }

  .message {
    max-width: 400px;
    margin: 10px 0;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class MainModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  showModal(action) {
    this.props.sendAction(action);
  }

  reset() {
    this.props.sendAction('close');
  }

  renderModalBulkActionButtons() {
    return (
      <div className={styles.buttonGridContainer}>
        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showEditModal')}>
          {this.lbl('edit')}
        </ButtonComponent>
        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showExcelModal')}>
          {this.lbl('vehicle.overview.excel_card.share_data')}
        </ButtonComponent>

        <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={() => this.showModal('showPrintCMRModal')}>
          {this.lbl('vehicle.overview.excel_card.print_cmr')}
        </ButtonComponent>
      </div>
    );
  }

  render() {
    return (
      <Container>
        <HBox>
          {window.innerWidth <= 768 && (
            <HBox vCenter left className="search-top">
              <Left />
              {this.lbl('vehicle.overview.bulk_actions')}
              <p className="list-result-label">{this.props.transportOrderIds?.length}</p>
            </HBox>
          )}
          <ModalComponent
            mobileView={this.props.mobileView}
            onClose={this.reset.bind(this)}
            title={this.lblStr('transport_order.overview.bulk_actions')}
          >
            <div className="message">
              <strong>{this.lbl('transport_order.bulk_actions.modal.title')}</strong>
            </div>
            {this.renderModalBulkActionButtons()}

            {this.props.mobileView && (
              <ModalControls className="mobile-btn-block" style={{ backgroundColor: '#fff' }}>
                <Button className="modal-footer-button" onClick={this.reset.bind(this)}>
                  {this.lbl(`cancel`)}
                </Button>
              </ModalControls>
            )}

            {!this.props.mobileView && (
              <div className="mt-2 d-flex justify-content-end">
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
                  {this.lbl(`cancel`)}
                </ButtonComponent>
              </div>
            )}
          </ModalComponent>
        </HBox>
      </Container>
    );
  }
}

MainModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const MainModal = compose(withConnect, withRouter, injectIntl)(MainModalComp);
